import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Field } from '@ontruck/orc';

const DayField = ({ value, onChange, label, hasError, nameKey = 'from' }) => {
  const timeMoment = moment(value);

  return (
    <DatePicker
      disabled={false}
      selected={timeMoment}
      onChange={onChange}
      customInput={
        <div>
          <Field
            label={label}
            fullWidth
            value={timeMoment.format('DD MMM')}
            invalid={hasError}
            name={`DayField-${nameKey}`}
            id={`DayField-${nameKey}`}
          />
        </div>
      }
    />
  );
};

export default DayField;
